import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import { Divider, Modal, Collapse, } from "antd";
import prompt from "antd-prompt";
import styled from "styled-components";
import { connect } from "react-redux";

// Components
import Title from "components/Title";
import Text from "components/Text";
import OptionsModal from "./components/OptionsModal";

// Utils
import { convertToArray } from "utils";
import { get } from "library/endpoints";
import useParentSupportCategories from "hooks/useSupportParentCategories";
import SupportParentCategoryPanel from "./components/SupportParentCategoryPanel";


const StyledModal = styled(Modal)`
  width: 740px !important;

  button.ant-btn-primary {
    background: ${ props => props.theme.buttonColor} !important;
  }

  @media screen and (max-width: 768px) {
    width: 98% !important;
  }
`;

const StyledCollapseWrapper = styled.div`
  width: 100%;
  margin: auto;
  margin-top: 20px;
`;

export const StyledCollapse = styled(Collapse)`
  background-color: white !important;
  border: 0px !important;


  .ant-collapse-item {
    border: 0px !important;
    margin-bottom: 20px;

    .ant-collapse-header {
      padding: 0px 0px 10px !important;
      font-size: 16px;
      border-bottom: 1px solid lightgrey;
      color: grey;
    }

    .ant-collapse-content {
      border-top: 0px !important;
    }
  }

`;

/**
 * SupportParentCategoriesModal
 * @param {*} props 
 * @returns 
 */
const SupportParentCategoriesModal = (props) => {
  const { supportParentCategories } = useParentSupportCategories({effectId: props.selectedMount._effect})

  const [supports, setSupports] = useState([]);
  const [options, setOptions] = useState([]);
  const [displayOptionsModal, setDisplayOptionsModal] = useState(false);
  const [displayMoreInfos, setDisplayMoreInfos] = useState(null);

  useEffect(() => {
    fetchSupports();
  }, []) // eslint-disable-line

  const fetchSupports = async () => {
    try {
      const response = await get(`/frontend/support-categories/${props.selectedMount._effect}`);
      const supportsToSet = response.data._support_category.supports.map((s) => {
        return {...s, supportCategoryId: response.data._support_category._id }
      })
      setSupports(supportsToSet);
    } catch (error) {
      console.log(error);
    }
  }

  const handleOnSelectVariant = async (support, variant) => {
    if (support.extra_infos) {
      const extraInfosResponse = await prompt({
        title: support.extra_infos,
        placeholder: "",
        rules: [
          {
            required: true,
            message: ""
          }
        ]
      });
      support.extra_infos_response = extraInfosResponse;
    }

    try {
      props.setSelectedSupport({...variant, parentSupport: support});
      if (!Array.isArray(variant.options)) {
        const optionsArr = convertToArray({...variant.options});
        setOptions(optionsArr)
        setDisplayOptionsModal(true);
      } else {
        props.handleOnAddToBasket({
          support: {...variant, parentSupport: support},
          mount: props.selectedMount,
          quantity: 1,
          options: []
        });
        props.onOk();
        props.setView('basket');
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleOnOptionsSelected = (options) => {
    props.handleOnAddToBasket({
      support: props.selectedSupport,
      mount: props.selectedMount,
      quantity: 1,
      options,
    });

    props.onOk();
    props.setView('basket');
  }

  const getAllVariantsFromSupportParentCategory = (supportParentCategory) => {
    const variants = []
    supportParentCategory.supportCategories.forEach((supportCategory) => {
      supportCategory.supports.forEach((support) => {
        if (!support.hide_from_frontend && support?._related_parent?.toString() === supportParentCategory._id.toString()) {
          support.variants.forEach((variant) => {
            if (!variant.is_not_public) {
              variants.push({...variant, supportCategory, support})
            }
          })
        }
      })
    })

    const extractNumbers = (name) => {
      const [width, height] = name.split(' x ').map(Number);
      return { width, height };
    };

    variants.sort((a, b) => {
      const aNumbers = extractNumbers(a.name);
      const bNumbers = extractNumbers(b.name);

      if (aNumbers.width === bNumbers.width) {
        return aNumbers.height - bNumbers.height;
      }
      return aNumbers.width - bNumbers.width;
    });

    return variants
  }

  if (!supports) {
    return null;
  }

  return (
    <StyledModal
      footer={null}
      visible={props.visible}
      onOk={props.onOk}
      onCancel={props.onCancel}
      style={{ top: 10 }}
      width={400}
      theme={props.ui.theme}
    >
      {
        displayOptionsModal && (
          <OptionsModal
            visible={displayOptionsModal}
            onOk={() => setDisplayOptionsModal(false)}
            onCancel={() => setDisplayOptionsModal(false)}
            handleOnOptionsSelected={handleOnOptionsSelected}
            selectedSupport={props.selectedSupport}
            options={options}
          />
        )
      }

      {
        displayMoreInfos && (
          <Modal
            visible={displayMoreInfos}
            onOk={() => setDisplayMoreInfos(null)}
            onCancel={() => setDisplayMoreInfos(null)}
            footer={null}
          >
            <Text style={{ marginTop: 20 }} size={14}>{displayMoreInfos.split('\n').map(e => <p>{ e }</p>)}</Text>
          </Modal>
        )
      }

      <Title size={18}>Sélectionnez votre support</Title>
      <Divider />

      <StyledCollapseWrapper>
        <StyledCollapse>
          {
            supportParentCategories && supportParentCategories.filter((supportParentCategory) => getAllVariantsFromSupportParentCategory(supportParentCategory).length > 0).map((supportParentCategory, index) => (
              <StyledCollapse.Panel header={supportParentCategory.name_i18n['fr']} key={`collapse-support-parent-category-${supportParentCategory._id}-${index}`}>
                <SupportParentCategoryPanel 
                  supportParentCategory={supportParentCategory}
                  getAllVariantsFromSupportParentCategory={getAllVariantsFromSupportParentCategory}
                  handleOnSelectVariant={handleOnSelectVariant}
                />
              </StyledCollapse.Panel>
            ))
          }
        </StyledCollapse>
      </StyledCollapseWrapper>
    </StyledModal>
  )
}

const stateToProps = state => ({
  ui: state.ui
})

export default connect(stateToProps)(withTranslation()(SupportParentCategoriesModal));